const INVOICE = 1;
const INPOST = 2;
const RUCH = 3;
const BUYER = 4;
const DROPSHIP = 5;
const COURIER = 6;

export {
    INVOICE,
    INPOST,
    RUCH,
    BUYER,
    DROPSHIP,
    COURIER,
}